module.exports = __webpack_public_path__ + "img/کارت-ویزیت-آهن-زابایی.818d76da.png";